module.exports = __webpack_public_path__ + "media/images/kv_sp-23dd8e6bc8a8a8b6feef0c33e046513a.jpg";